var _style, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoBrandCompetition = function SvgLogoBrandCompetition(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Wettbewerbslogo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "260px",
    height: "70px",
    viewBox: "0 0 260 70",
    style: {
      enableBackground: "new 0 0 260 70"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000137092544781498261480000007574863464874318498_);}\r\n\t.st1{fill:#003869;}\r\n\t.st2{fill:#00A8E1;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 3,
    width: 254,
    height: 70
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026131278551306134680000016017458925507585936_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_maskieren_42",
    style: {
      clipPath: "url(#SVGID_00000026131278551306134680000016017458925507585936_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2_00000010270810597118886850000011581152034275897530_",
    transform: "translate(0 8.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2276",
    transform: "translate(59.711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2274",
    transform: "translate(0.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2273",
    transform: "translate(0 3.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11749",
    className: "st1",
    d: "M3,22.4l3.6-0.2c0.2,1.2,0.4,2.6,1.7,2.6s1.4-0.9,1.4-1.8S9,21.1,7.9,20.1L6,18.3 c-1.7-1.7-2.8-3.2-2.8-5.4c0-2.7,2.3-4.9,5-4.9c0,0,0.1,0,0.1,0c3.5,0,4.7,1.2,4.9,5.5l-3.4,0.2c-0.2-1.4-0.4-2.6-1.7-2.6 s-1.3,0.7-1.3,1.7s1.1,2,2,2.9l1.7,1.7c1.9,1.8,2.8,3.5,2.8,5.5c0.1,2.7-1.9,5-4.6,5.1c0,0,0,0,0,0H8.1 C5.1,28,3.2,25.8,3,22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11750",
    className: "st1",
    d: "M18.2,11.5h-3.7V8.4h11.2v3.1H22v16.1h-3.9V11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11751",
    className: "st1",
    d: "M28.8,8.4h5.3l3.7,19.4H34l-0.8-4.4h-4l-0.7,4.4h-3.6L28.8,8.4z M32.5,20.3l-1.3-7.7 h-0.1l-1.3,7.7H32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11752",
    className: "st1",
    d: "M38.6,8.4h5.6c2.9,0,5.2,1.5,5.2,4.6v9.8c0,3.4-2.3,5-5.2,5h-5.6V8.4z M43.9,24.3 c0.9,0,1.7-0.7,1.7-1.6c0,0,0,0,0,0v-9.4c0.1-0.9-0.5-1.6-1.4-1.7c0,0-0.1,0-0.1,0h-1.7v12.8H43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11753",
    className: "st1",
    d: "M54.3,11.5h-3.7V8.4h11.2v3.1h-3.6v16.1h-3.8L54.3,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11754",
    className: "st1",
    d: "M62.3,8.4h3.8l1.5,11.5h0.1l1.7-11.6h3.7l1.7,11.5h0.1l1.6-11.5h3.3l-3.1,19.4h-3.6 l-1.9-12.3H71l-2,12.3h-3.6L62.3,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11755",
    className: "st1",
    d: "M81.5,8.4h9.3v3.1h-5.5v4.6h4.3v3.2h-4.3v5h5.5v3.3h-9.4L81.5,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11756",
    className: "st1",
    d: "M93.3,8.4h5.6c3.1,0,5.2,1.8,5.2,5.7s-0.9,4.4-2.2,5.1l2.6,8.5h-4l-1.9-7.6h-1.3v7.6 h-3.8V8.4H93.3z M98.6,17.1c1.1,0,1.7-0.7,1.7-2.9s-0.5-2.8-1.7-2.8h-1.3v5.6L98.6,17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11757",
    className: "st1",
    d: "M106.6,8.4h3.8v8.5l3.7-8.5h3.8l-3.5,7.5l3.5,11.8h-4.1l-2.2-8.5l-1.2,2.2v6.3h-3.8 L106.6,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11758",
    className: "st1",
    d: "M120.1,8.4h9.3v3.1h-5.5v4.6h4.4v3.2h-4.4v5h5.6v3.3h-9.4L120.1,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11759",
    className: "st1",
    d: "M136.3,8.4h1.9v9.7l5.1-9.8h1.8l-3.7,7.4l3.8,12h-1.9L140,17.5l-1.8,3.3v6.9h-1.9 L136.3,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11760",
    className: "st1",
    d: "M147.9,8.4h1.9v19.4h-1.9V8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11761",
    className: "st1",
    d: "M153.4,8.4h7.2v1.5h-5.5v6.8h4.4v1.7h-4.4V26h5.5v1.7h-7.2V8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11762",
    className: "st1",
    d: "M163,8.4h1.8v17.7h5.4v1.7h-7.3L163,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11763",
    className: "st1",
    d: "M191.3,0l-0.5,2h3l-3.5,13.6h2.3L196.7,0L191.3,0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11764",
    className: "st2",
    d: "M190.4,0l-3.8,15.4v-4.1h-2v1.5h-1.2l2.3-9.2h-1.5l0.9-3.6h-0.6l-4.4,17.1h-3l1.8-7 c0.4-1.7,0.5-2.1,0.7-3.4c0.4-1.3-0.3-2.6-1.6-3c-0.1,0-0.2,0-0.2-0.1c-0.3-0.1-0.6-0.1-0.8-0.1c-1.4-0.2-2.7,0.9-2.9,2.3 c0,0.1,0,0.2,0,0.2v1.2h2.2V6.1c0-0.3,0.2-0.6,0.6-0.7c0.3,0,0.5,0.2,0.5,0.7c-0.1,0.8-0.2,1.6-0.4,2.3L174.4,19h5.2l-0.9,3.6 h0.6l2-8h3.1V19h1.1l-0.9,3.6h1.8L192.1,0L190.4,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2275",
    transform: "translate(0 40.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11765",
    className: "st1",
    d: "M3,0.2h6.8v0.8H4v3.5h4.8v0.7H4v3.8h5.8v0.7H3V0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11766",
    className: "st1",
    d: "M12,0.2h1v4.2h6V0.2h0.9v9.5H19V5.1h-6v4.6h-1V0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11767",
    className: "st1",
    d: "M22.5,0.2h3.7c2.1,0,3.5,1.1,3.5,2.8s-0.9,2.5-2.8,2.7l3.3,4h-1.1l-3.2-3.9h-2.5v3.9 h-0.9V0.2z M25.9,5.1c1.8,0,2.8-0.7,2.8-2.1s-1.1-2.1-2.8-2.1h-2.5v4.1L25.9,5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11768",
    className: "st1",
    d: "M32.1,0.2h6.8v0.8h-5.8v3.5h4.8v0.7h-4.8v3.8h5.9v0.7h-6.9V0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11769",
    className: "st1",
    d: "M41.2,0.2h1l5.9,8l0,0v-8H49v9.5h-0.9l-6-8.2H42v8.2h-0.8V0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11770",
    className: "st1",
    d: "M54.9,0.2h0.9l4,9.5h-1l-1.2-3H53l-1.2,3h-1L54.9,0.2z M57.3,6l-2-4.8l0,0l-2,4.8H57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11771",
    className: "st1",
    d: "M61.7,0.2h1.2L66.5,6l0,0l3.6-5.8h1.2v9.5h-1v-8l0,0l-3.5,5.5h-0.7l-3.5-5.5l0,0v8h-0.9 L61.7,0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11772",
    className: "st1",
    d: "M76.7,0.9h-3.6V0.2h8.3v0.8h-3.6v8.8h-1L76.7,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11773",
    className: "st1",
    d: "M82.2,7.6l0.9-0.3c0.5,1.2,1.8,2,3.1,1.8c1.6,0,2.7-0.7,2.7-1.9s-0.7-1.5-1.7-1.8 l-2.2-0.5c-1.6-0.4-2.3-1.2-2.3-2.4S84.2,0,86.2,0s3,0.6,3.6,1.7l-0.8,0.3c-0.6-0.9-1.7-1.4-2.7-1.3c-1.2,0-2.5,0.5-2.5,1.7 s0.5,1.4,1.9,1.7l2.2,0.6c1.2,0.1,2.2,1.2,2.2,2.4c0,1.6-1.4,2.7-3.7,2.7S82.7,9,82.2,7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11774",
    className: "st1",
    d: "M91.9,0.2h3.7c2.1,0,3.5,1.2,3.5,2.8s-1.4,2.9-3.7,2.9h-2.6v3.8h-0.9V0.2z M95.2,5.1 c1.8,0,3-0.7,3-2.2s-1.1-2.1-2.6-2.1h-2.6v4.2L95.2,5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11775",
    className: "st1",
    d: "M101.1,0.2h3.7c2.1,0,3.6,1.1,3.6,2.8s-0.9,2.5-2.9,2.7l3.4,4h-1.2l-3.2-3.9h-2.4v3.9h-1 L101.1,0.2z M104.6,5.1c1.8,0,2.8-0.7,2.8-2.1s-1.1-2.1-2.9-2.1h-2.4v4.1L104.6,5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11776",
    className: "st1",
    d: "M110.7,0.2h6.8v0.8h-5.9v3.5h4.9v0.7h-4.9v3.8h5.9v0.7h-6.8V0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11777",
    className: "st1",
    d: "M119.8,0.2h1v9.5h-1V0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11778",
    className: "st1",
    d: "M122.7,7.6l0.9-0.3c0.5,1.2,1.8,2,3.1,1.8c1.6,0,2.7-0.7,2.7-1.9s-0.7-1.5-1.7-1.8 l-2.2-0.5c-1.6-0.4-2.3-1.2-2.3-2.4s1.5-2.5,3.4-2.5s3,0.6,3.6,1.7l-0.8,0.3c-0.6-0.9-1.6-1.4-2.7-1.3c-1.2,0-2.5,0.5-2.5,1.7 s0.5,1.4,1.9,1.7l2.2,0.6c1.2,0.1,2.2,1.2,2.2,2.4c0,1.6-1.4,2.7-3.7,2.7S123.2,9,122.7,7.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11779",
    className: "st1",
    d: "M41.3,35.9c3.2-3.8,5-8.6,5.1-13.6c0-6.5-5-11.8-11.2-11.8s-9.8,2.7-10.5,3.4 c-3-2.3-6.7-3.5-10.5-3.4C8.1,10.4,3,15.8,3,22.3c0.1,4.1,1.4,8,3.6,11.4c0.2,1.9,0.9,3.8,1.9,5.5c0.9,1.7,1.7,3.1,1.7,3.9l0,0 c-0.4,0-0.7,0.3-0.7,0.7c-0.3,1-0.5,1.9-0.7,2.9v6.5c0,0.4,0.3,0.7,0.7,0.7c0,0,0,0,0,0H40c0.4,0,0.7-0.4,0.7-0.7v-6.5 c0-0.4-0.7-2.9-0.7-2.9c0-0.4-0.3-0.7-0.7-0.7h-0.7c0.3-0.9,0.7-1.8,1.2-2.7C40.7,39,41.2,37.5,41.3,35.9z M6.6,29.6v1.1 c-1.4-2.6-2.2-5.5-2.2-8.4c0-5.8,4.4-10.4,9.8-10.4s9.9,3.5,9.9,3.5l0,0l0.6,0.2l0.5-0.2c0,0,3.4-3.5,10-3.5s9.8,4.6,9.8,10.4 c-0.1,3.9-1.4,7.7-3.6,10.9v-4.6c0-1.2-0.9-2.2-2.1-2.2l-0.7,0.2v-0.2c0-1.2-1-2.2-2.2-2.2c0,0,0,0,0,0l-0.7,0.2v-0.2 c0-1.2-1-2.2-2.2-2.2c0,0,0,0,0,0c-0.5,0-1.1,0.2-1.5,0.6c-0.4-0.4-0.9-0.6-1.4-0.6l-0.7,0.2v-0.9c0-1.2-1-2.2-2.2-2.2 c0,0,0,0,0,0h-0.7c0-1.2-1-2.2-2.3-2.1c-1,0-1.8,0.7-2.1,1.6l-0.7-0.2c-1.2,0-2.2,1-2.2,2.2V23c-0.3-0.2-0.7-0.3-1.1-0.2 c-0.5,0-0.9,0.2-1.3,0.4c-0.4-0.7-1.1-1.2-1.9-1.2c-1,0-1.8,0.6-2.1,1.6l-0.8-0.2c-1.2,0-2.2,1-2.2,2.2c0,0,0,0.1,0,0.1v1.7 c-0.4-0.2-0.8-0.3-1.2-0.2C7.7,27.1,6.6,28.3,6.6,29.6L6.6,29.6z M20.1,29.2c0,0,2.5,1.2,2.5,3.6c0,0.4,0.3,0.7,0.7,0.7 c0.4,0,0.7-0.3,0.7-0.7c-0.1-2-1.2-3.8-2.9-4.7v-7.6c0-0.4,0.4-0.7,0.7-0.7c0.4,0,0.6,0.3,0.7,0.7v5.1c0,0.4,0.3,0.7,0.7,0.7 c0.4,0,0.7-0.3,0.7-0.7v-6.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7c0,0,0,0.1,0,0.1v7.2c0,0.4,0.3,0.7,0.7,0.7 c0.4,0,0.7-0.3,0.7-0.7v-5.1c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7c0,0,0,0.1,0,0.1v6.5c0,0.4,0.3,0.7,0.7,0.7 c0.4,0,0.7-0.3,0.7-0.7v-3.6c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7c0,0,0,0.1,0,0.1v5.1l0,0c0.1,2.1-0.4,4.2-1.3,6 c-0.7,1-1.2,2.1-1.5,3.3h-7.3c0-1.3-1-2.8-1.9-4.5c-1-1.7-1.6-3.6-1.7-5.6v-3.3c0-0.6,0.4-1.1,1-1.1c0.6,0,1.1,0.4,1.1,1 c0,0,0,0,0,0.1v3.3C19.7,28.8,19.8,29.1,20.1,29.2z M18.2,52.5h-8v-5.1h8L18.2,52.5z M19,39.4c-0.3,1-0.5,1.9-0.7,2.9v0.7h-6.5 c0-1.4-1.1-2.9-2-4.6l0,0c-1-1.7-1.6-3.6-1.7-5.6v-3.2c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1v3.2c0,0.3,0.1,0.6,0.3,0.7 c1.5,0.7,2.5,2.1,2.6,3.7c-0.1,0.4,0.1,0.8,0.5,0.9s0.8-0.1,0.9-0.5c0.1-0.2,0.1-0.3,0-0.5c-0.1-2-1.2-3.8-2.9-4.8v-6.8 c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v5.1c-0.1,0.4,0.1,0.8,0.5,0.9c0.4,0.1,0.8-0.1,0.9-0.5c0.1-0.2,0.1-0.3,0-0.5 v-5.1l0,0v-1.5c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v1.1l0,0v3.3c0.1,2.2,0.7,4.4,1.9,6.3c0.9,1.7,1.7,3,1.7,3.8h-0.1 C19.3,38.7,19,39,19,39.4L19,39.4z M30.2,51.7h-11v-3h11V51.7z M30.2,46.7h-11v-3h11V46.7z M39.3,47.4v5.1h-8v-5.1L39.3,47.4z  M37.1,43.1h-5.9v-0.7c0-0.4-0.7-2.9-0.7-2.9c-0.1-0.4-0.3-0.7-0.7-0.7c0.3-0.9,0.7-1.8,1.2-2.7c1.2-2,1.7-4.4,1.6-6.7v-5.1 c0-0.4,0.3-0.7,0.7-0.7l0,0c0.4,0,0.7,0.4,0.7,0.7v7.3c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7l0,0v-5.1 c0-0.4,0.3-0.7,0.7-0.7c0,0,0.1,0,0.1,0c0.4,0,0.7,0.3,0.7,0.7v5.8c0,0.7,0.5,0.9,0.9,0.7c0.3-0.1,0.6-0.4,0.5-0.7v-3.6 c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v5.1c0.1,2.1-0.4,4.2-1.4,6C37.9,40.7,37.4,41.9,37.1,43.1L37.1,43.1z"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBrandCompetition);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-brand-competition.eb4cb3d49509d7964c0f8735ac4e5178.svg";